import PushNotificationService from '@/business/modules/push-notification/pushNotification.service';

function urlBase64ToUint8Array(base64String: string) {
	const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}

	return outputArray;
}

function arrayBufferToBase64Url(buffer: ArrayBuffer | null) {
	if (!buffer) return '';

	const bytes = new Uint8Array(buffer);
	let binary = '';
	bytes.forEach((byte) => {
		binary += String.fromCharCode(byte);
	});

	return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

function canUsePushNotifications() {
	return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function setupPushNotifications() {
	if (!canUsePushNotifications()) return;
	if (Notification.permission === 'denied') return;

	const pushNotificationService = PushNotificationService.getInstance();
	const publicKeyResponse = await pushNotificationService.getPublicKey();
	const publicKey = publicKeyResponse?.data?.publicKey;
	if (!publicKey) return;

	const permission = Notification.permission === 'granted' ? 'granted' : await Notification.requestPermission();
	if (permission !== 'granted') return;

	const registration = await navigator.serviceWorker.getRegistration();
	if (!registration?.active) return;

	const existingSubscription = await registration.pushManager.getSubscription();
	const subscription =
		existingSubscription ||
		(await registration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(publicKey),
		}));

	const p256dh = subscription.getKey('p256dh');
	const auth = subscription.getKey('auth');

	await pushNotificationService.subscribe({
		endpoint: subscription.endpoint,
		keys: {
			p256Dh: arrayBufferToBase64Url(p256dh),
			auth: arrayBufferToBase64Url(auth),
		},
		userAgent: navigator.userAgent,
	});
}
